module.exports = __webpack_public_path__ + "img/apple3.050545da.png";